import { signInWithPopup, GoogleAuthProvider, signInWithCredential } from "firebase/auth";
import { auth, provider, db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { GoogleSignIn } from "@capawesome/capacitor-google-sign-in";
import { Capacitor } from "@capacitor/core";

const WEB_CLIENT_ID =
  "625826958986-l25puope7163t6lcis0n1is6dpgepgvo.apps.googleusercontent.com";

let googleInitialized = false;

async function initializeGoogleSignIn() {
  if (googleInitialized) return;

  await GoogleSignIn.initialize({
    clientId: WEB_CLIENT_ID,
  });

  googleInitialized = true;
}

function Login({ onSuccess }) {

  const saveUser = async (user) => {
    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      await setDoc(userRef, {
        name: user.displayName,
        email: user.email,
        premium: false,
        createdAt: new Date().toISOString()
      });
    }

    onSuccess(user);
  };

  const googleLogin = async () => {
    try {
      let user;

      if (Capacitor.getPlatform() === "android") {
        // Native Google Sign-In for Android
        await initializeGoogleSignIn();

        const result = await GoogleSignIn.signIn();

        if (!result.idToken) {
          throw new Error("Google ID Token नहीं मिला।");
        }

        const credential = GoogleAuthProvider.credential(
          result.idToken
        );

        const firebaseResult = await signInWithCredential(
          auth,
          credential
        );

        user = firebaseResult.user;

      } else {
        // Normal Firebase Google Login for Web
        const result = await signInWithPopup(auth, provider);
        user = result.user;
      }

      await saveUser(user);

    } catch (error) {
      console.error("Google Login Error:", error);
      alert(error.message || "Google Login failed");
    }
  };

  return (
    <div style={{ textAlign: "center", marginTop: "40px" }}>
      <h2>🔐 Login</h2>

      <button onClick={googleLogin}>
        Continue with Google
      </button>

      <br /><br />

      <button>
        Login with Mobile OTP
      </button>
    </div>
  );
}

export default Login;
